import * as React from 'react';

import { DataSourceTable } from 'src/constants/dataSourceTable';

export const useTableLabel = (tables: DataSourceTable[]) => {
  const showCatalog = React.useMemo(
    () => new Set(tables.map((table) => table.catalog)).size > 1,
    [tables]
  );

  const showSchema = React.useMemo(
    () => new Set(tables.map((table) => table.schema)).size > 1,
    [tables]
  );

  const getTableLabel = React.useCallback(
    (table: DataSourceTable) => {
      const { catalog, schema, name } = table;
      return [
        showCatalog ? `${catalog}.` : null,
        showSchema ? `${schema}.` : null,
        name,
      ].join('');
    },
    [showCatalog, showSchema]
  );

  return getTableLabel;
};
